"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDocConversionModal = exports.getDocUploadUrl = exports.createDocUploaderStore = exports.BASE_CLASS_NAME = void 0;
var react_1 = __importDefault(require("react"));
var axios_1 = __importDefault(require("axios"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Telemetry_1 = require("Telemetry");
var DocUploaderStore_1 = __importDefault(require("./../Stores/DocUploaderStore"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
exports.BASE_CLASS_NAME = "dashboard-doc-uploader";
var DocUploader = (function (_super) {
    __extends(DocUploader, _super);
    function DocUploader(props) {
        var _this = _super.call(this, props) || this;
        _this.fileInput = react_1.default.createRef();
        return _this;
    }
    DocUploader.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME) },
                react_1.default.createElement("header", { className: "header" },
                    react_1.default.createElement("h3", { className: "title" }, "Automated Doc Conversion"),
                    react_1.default.createElement("p", { className: "explainer" }, "Upload a docx file then it will be converted to a Qwilr page automatically")),
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__input-form center") },
                    react_1.default.createElement("input", { className: "".concat(exports.BASE_CLASS_NAME, "__input"), type: "file", ref: this.fileInput, onChange: this.onFileChange }),
                    react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__wrap") },
                        this.props.docUploaderStore.selectedFile ? (react_1.default.createElement(icons_1.Tick, { size: icons_1.IconSize.Large })) : (react_1.default.createElement(icons_1.Upload, { size: icons_1.IconSize.Large })),
                        react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__upload-description") }, this.props.docUploaderStore.selectedFile ? "Selected" : "Add file"))),
                this.props.docUploaderStore.selectedFile && (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__selected-file-name") }, this.props.docUploaderStore.selectedFile.name)),
                this.props.docUploaderStore.errorMessage && (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__error-message") }, this.props.docUploaderStore.errorMessage)))));
    };
    DocUploader.prototype.onFileChange = function () {
        this.props.docUploaderStore.setErrorMessage(undefined);
        var files = this.fileInput.current && this.fileInput.current.files;
        this.props.docUploaderStore.setSelectedFile(files && files.length > 0 ? files[0] : undefined);
    };
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], DocUploader.prototype, "onFileChange", null);
    DocUploader = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], DocUploader);
    return DocUploader;
}(react_1.default.Component));
exports.default = DocUploader;
var createDocUploaderStore = function () {
    return new DocUploaderStore_1.default();
};
exports.createDocUploaderStore = createDocUploaderStore;
var getDocUploadUrl = function (uploadId, uploadStore) {
    return new Promise(function (resolve) {
        (0, mobx_1.reaction)(function () {
            var uploadProgress = uploadStore.getUploadProgress(uploadId);
            return uploadProgress && uploadProgress.url;
        }, function (url, reaction) {
            if (url) {
                reaction.dispose();
                resolve(url);
            }
        });
    });
};
exports.getDocUploadUrl = getDocUploadUrl;
var createDocConversionModal = function (uploadStore, projectService, apiBaseUrl, modal) { return __awaiter(void 0, void 0, Promise, function () {
    var docUploaderStore;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                docUploaderStore = (0, exports.createDocUploaderStore)();
                return [4, modal.showConfirmModal({
                        header: react_1.default.createElement(DocUploader, { docUploaderStore: docUploaderStore }),
                        confirmLabel: "Upload",
                        confirming: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var file, uploadId, uploadUrl, response, projectId, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        file = docUploaderStore.selectedFile;
                                        if (!docUploaderStore.isFileValid) {
                                            throw new Error(docUploaderStore.errorMessage);
                                        }
                                        if (!file) {
                                            throw new Error("Invalid file");
                                        }
                                        uploadId = uploadStore.upload(file);
                                        return [4, (0, exports.getDocUploadUrl)(uploadId, uploadStore)];
                                    case 1:
                                        uploadUrl = _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        _a.trys.push([2, 6, , 7]);
                                        return [4, axios_1.default.post("".concat(apiBaseUrl, "/projects/doc-conversion"), { fileName: uploadUrl, originalFileName: file.name }, { withCredentials: true })];
                                    case 3:
                                        response = _a.sent();
                                        projectId = response.data.projectId;
                                        if (!projectId) return [3, 5];
                                        return [4, projectService.open({ _id: projectId }, Telemetry_1.ProjectOpenedOrigin.DocConversion)];
                                    case 4:
                                        _a.sent();
                                        _a.label = 5;
                                    case 5: return [3, 7];
                                    case 6:
                                        error_1 = _a.sent();
                                        docUploaderStore.setErrorMessage("Sending the file for doc conversion failed");
                                        throw new Error((error_1 && error_1.response && error_1.response.data && error_1.response.data.message) || error_1.message);
                                    case 7: return [2];
                                }
                            });
                        }); },
                    })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
exports.createDocConversionModal = createDocConversionModal;
